/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mapIcon[_ngcontent-%COMP%]{color:red;cursor:pointer}\n/*# sourceMappingURL=endereco-pf.component.css.map*/"];
export { styles as styles };
